<template>
  <div>
    <vs-popup
      v-if="!!chatTicket && !!chatTicket.user"
      class="attendance-popup"
      title="Dados do Atendimento"
      :active.sync="attendancePopupIsActive"
      @close="closePopup"
      id="sizePopup"
    >
      <vs-row class="mt-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span>Atendente:</span>
        </vs-col>
      </vs-row>
      <vs-row class="mt-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <img
            v-if="chatTicket.user.image"
            key="onlineImg"
            :src="chatTicket.user.image"
            alt="user-img"
            width="40"
            height="40"
            style="margin-right: 10px"
            class="rounded-full shadow-md cursor-pointer block"
          />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <span v-if="chatTicket.user.deleted_at" style="font-weight: bold; margin-right: 5px;">Usuário Removido</span>
          <span>{{ chatTicket.user.name }}</span>
        </vs-col>
      </vs-row>
      <vs-row class="mt-4 mb-2" v-if="chatTicket.finished_at === null">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vs-button
            class="attendance-span"
            v-if="ticketTransfer === null && chatTicket.user.id !== activeUserInfo.id && !chatTicket.isTransferring && chatTicket.is_research !== 1"
            @click.prevent="openRequestTransferModal"
          >
            <span>
              PEDIR ATENDIMENTO
            </span>
          </vs-button>
          
          <vs-button
            class="attendance-span"
            v-else-if="ticketTransfer !== null && chatTicket.user.id !== activeUserInfo.id"
            @click.prevent="openTransferModal"
          >
            <span>
              VISUALIZAR TRANSFERÊNCIA
            </span>
          </vs-button>
          <span v-else-if="chatTicket.isTransferring">
            O atendimento já está sendo transferido
          </span>
          <span v-else-if="!chatTicket.isTransferring && !chatTicket.is_research" class="text-center">
            Esse atendimento já está com você
          </span>
          <span v-if="chatTicket.is_research === 1" class="text-center">
            Não é possível pedir atendimento enquanto a pesquisa de satisfação estiver aberta.
          </span>
        </vs-col>
      </vs-row>
      <div v-else style="height: 10px;"></div>
    </vs-popup>

    <vs-popup
      class="ticket-request-transfer-modal"
      title="Pedir atendimento"
      :active.sync="ticketRequestTransferModal"
      @close="closePopup"
    >
    
      <span>Ao clicar no botão abaixo, você irá pedir uma transferência desse atendimento para você.</span>

      <div class="flex flex-wrap items-center justify-center">
        <vs-button
          class="mr-4 mt-4 sm:mb-0 mb-2"
          type="filled"
          color="rgb(62, 201, 214)"
          @click.prevent="requestTransfer"
        >
          PEDIR ATENDIMENTO
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup
      class="ticket-transfer-modal"
      title="Transferindo atendimento"
      :active.sync="ticketTransferModal"
      v-if="ticketTransfer"
      @close="closePopup"
    >
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span v-if="ticketTransfer.nextUser.id === activeUserInfo.id">
            O pedido do atendimento foi feito.
          </span>
          <span v-else>
            O pedido do atendimento foi feito pelo usuário {{ ticketTransfer.nextUser.name }}.
          </span>
        </vs-col>
      </vs-row>
      <vs-row class="mt-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span v-if="ticketTransfer.nextUser.id === activeUserInfo.id">
            Se não houver resposta em:
          </span>
          <span v-else>
            Se não houver resposta do usuário {{ ticketTransfer.previousUser.name }} em:
          </span>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <vue-countdown :time="timer" v-slot="{ minutes, seconds }" @end="closeTicketTransfer">
            <span class="timer">{{ minutes }}:{{ seconds }}</span>
          </vue-countdown>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span>
            O atendimento será transferido automaticamente.
          </span>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import { getCurrentTenant, hasPermission } from '@/utils'
import VueCountdown from '@chenfengyuan/vue-countdown';
import ticketTransferApi from '@/http/requests/ticketTransfer'
import { ChatTicketService } from "@/db/chatTicket_service";

export default {
  components: {
    VueCountdown
  },
  data() {
    return {
      ticketRequestTransferModal: false,
      ticketTransferModal: false,
      ticketTransfer: null,
      timer: 0,
      attendancePopupIsActive: false
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    limitChatTicketsActivated() {
      return this.$store.state.settings.settings.limit_chat_tickets_activated;
    },
    setting() {
      return this.$store.state.settings.settings.limit_chat_tickets;
    },
    chatActives(){
      return this.$store.state.chat.chatActives
    },
    chatTicket() {
      return this.$store.state.chatContact.chatContactDropdown
    }
  },
  watch: {
    '$store.state.chatContact.attendancePopupIsActive': async function (val) {
      if (this.chatTicket) {
        this.ticketTransfer = null
        await this.getTicketTransfer()
      }

      await this.sleep(150)

      this.attendancePopupIsActive = val
    }
  },
  methods: {
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    closeTicketTransfer() {
      this.ticketTransfer = false;
    },
    canSee(action) {
        return hasPermission(`${this.$route.name}-${action}`)
    },
    updateTimer() {
      if (this.ticketTransfer) {
        this.timer = new Date(this.ticketTransfer.transfer_at) - new Date()
      }

      return 0
    },
    closePopup() {
      this.ticketTransfer = null
      this.$store.dispatch('chatContact/changeStatusAttendancePopupActive', false);
    },
    openRequestTransferModal() {
      this.$store.dispatch('chatContact/changeStatusAttendancePopupActive', false);
      this.ticketRequestTransferModal = true
    },
    openTransferModal() {
      this.updateTimer()
      this.$store.dispatch('chatContact/changeStatusAttendancePopupActive', false);
      this.ticketTransferModal = true
    },
    async requestTransfer() {
      const ctService = new ChatTicketService()
      if (Number(this.limitChatTicketsActivated) && !(
        this.activeUserInfo.role.name === "administrador" || this.setting > await ctService.getCountChatActive()
      )) {
        return this.$vs.notify({
          color: "danger",
          title: "Limite de atendimentos atingido!",
          text: "Você não pode pegar este atendimento porque o limite de atendimentos simultâneos foi atingido."
        })
      }

      const that = this
      this.ticketRequestTransferModal = false
      this.chatTicket.isTransferring = true
      this.$events.emit('ChatTicketTransferringLabelUpdate', {
        chatTicket: this.chatTicket,
        isTransferring: true
      })
      this.$store.dispatch('ticketTransfer/add', {
        nextUserId: this.activeUserInfo.id,
        previousUserId: this.chatTicket.user.id,
        chatTicketId: this.chatTicket.id
      }).then(async (response) => {
        let initialRole = "administrador"
        let userInfo = JSON.parse(localStorage.getItem("userInfo"))

        if (userInfo && userInfo.role) {
          if ((initialRole === userInfo.role.name) || this.canSee('pull')) {
            this.ticketRequestTransferModal = false
            await new Promise(resolve => setTimeout(resolve, 100));
            return
          }
        }

        this.$store.dispatch('chat/chatActives', this.chatActives + 1)

        this.ticketTransfer = response.data.data.createTicketTransfer
        this.updateTimer()
        this.ticketRequestTransferModal = false
        this.ticketTransferModal = true

        that.$events.on('ChatTicketTransferredDropDown', async ({ chatTicket, instanceId, tenantName }) => {
          if (
            getCurrentTenant() === tenantName &&
            this.chatTicket.id === chatTicket.id &&
            this.activeUserInfo.id === chatTicket.user_id &&
            this.$store.getters["instance/chosenInstanceIds"].includes( instanceId )
          ) {
            that.ticketTransferModal = false
            await new Promise(resolve => setTimeout(resolve, 800));
            this.$store.dispatch('setShowLoadingOverlay', false)
          }
        })

        that.$events.on('DeleteChatTicketTransferCloseModal', async ({ ticketTransfer, instanceId, tenantName }) => {
          if (
            getCurrentTenant() === tenantName &&
            this.activeUserInfo.id === ticketTransfer.next_user_id &&
            this.$store.getters["instance/chosenInstanceIds"].includes( instanceId )
          ) {
            that.ticketTransferModal = false
            that.ticketTransfer = null
          }
        })
      }).catch((error) => { console.error(error) })
    },
    getTicketTransfer() {
      if (this.chatTicket) {
        ticketTransferApi.fetch(this.chatTicket.id, false).then((response) => {
          if (response.data.data.ticketTransfer[0]) {
            this.ticketTransfer = response.data.data.ticketTransfer[0]

            if (
                this.ticketTransfer !== null &&
                this.chatTicket.user.id !== this.activeUserInfo.id &&
                this.activeUserInfo.id === this.ticketTransfer.nextUser.id
            ) {
              this.$store.dispatch('chat/chatActives', this.chatActives + 1)
            }
          }
        }).catch((error) => { console.error(error) })
      }
    }
  },
  created() {
    this.$events.on('FetchTicketTransfer', () => {
      this.getTicketTransfer()
    })

    if (this.chatTicket) {
      this.getTicketTransfer()
    }
  }
}
</script>

<style lang="scss" scoped>
  .vs-dialog-text {
    white-space: pre-line;
  }

  .timer {
    font-size: 2rem;
    color: $PRIMARY_COLOR;
  }

  .vs-button-filled {
    color: #fff !important;
  }
</style>

<style>
#sizePopup {
  width: 100%;
  height: 100%;
}
</style>